import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { soleOptionValue, type ResolvedOption } from "./resolveDictionary";

/** When a chained step has exactly one choice, pick it so the user is not stuck on an extra click. */
export function useAutoSelectSoleOption({
    name,
    options,
    enabled = true,
}: {
    name: string;
    options: readonly ResolvedOption[];
    enabled?: boolean;
}) {
    const { setValue, watch } = useFormContext();
    const current = watch(name);
    const sole = soleOptionValue(options);

    useEffect(() => {
        if (!enabled || sole == null) return;
        if (current !== sole) {
            setValue(name, sole, { shouldDirty: true, shouldValidate: false });
        }
    }, [enabled, sole, current, name, setValue]);
}
